// extracted by mini-css-extract-plugin
export default {"page_header":"SendInfo_page_header__6msGF","markerIcon":"SendInfo_markerIcon__V8a9d","markerSpan":"SendInfo_markerSpan__DH-ai"};